<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaExames"
        title-table="Exames"
        module="exameSettingsModule"
        sort-name="descricao"
        add-permission="ROLE_EXAME_INSERIR"
        view-permission="ROLE_EXAME_CONSULTAR"
        edit-permission="ROLE_EXAME_ATUALIZAR"
        delete-permission="ROLE_EXAME_DELETAR"
        :search-field="'descricao'"
        @add="addNew"
        @edit="edit"
      />
      <FormExame
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormExame from './forms/FormExame.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormExame,
  },
  computed: {
    ...mapState('exameSettingsModule', {
      listaExames: state => state.listaExames,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
        },
        {
          label: 'Descrição',
          field: 'descricao',
        },
        {
          label: 'Especialidade',
          field: 'especialidade.descricao',
        },
        {
          label: 'Ativo',
          field: 'ativo',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.$store.dispatch('exameSettingsModule/resetExame')
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('exameSettingsModule/prepareToEditExame', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
